export function actionsNs(
  api: { namespace: string; actions: { [name: string]: string } },
  name: string
) {
  console.assert(name in api.actions, "Invalid action name  for", api, name);
  return [api.namespace, name].join("/");
}
export function mutationsNs(
  api: { namespace: string; mutations: { [name: string]: string } },
  name: string
) {
  console.assert(
    name in api.mutations,
    "Invalid mutation name  for",
    api,
    name
  );
  return [api.namespace, name].join("/");
}
export function gettersNs(
  api: { namespace: string; getters: { [name: string]: string } },
  name: string
) {
  console.assert(name in api.getters, "Invalid getter name  for", api, name);
  return [api.namespace, name].join("/");
}
